import { Country, CountryCode, DataCenter, DataCenterCode, Language, LanguageCode, Locale } from 'i18n/types';

export const LANGUAGES: Readonly<Record<LanguageCode, Language>> = {
  [LanguageCode.ENGLISH]: {
    displayName: 'English',
    code: LanguageCode.ENGLISH,
  },
  [LanguageCode.FRENCH]: {
    displayName: 'Français',
    code: LanguageCode.FRENCH,
  },
  [LanguageCode.SPANISH]: {
    displayName: 'Español',
    code: LanguageCode.SPANISH,
  },
  [LanguageCode.GERMAN]: {
    displayName: 'Deutsch',
    code: LanguageCode.GERMAN,
  },
  [LanguageCode.DUTCH]: {
    displayName: 'Nederlands',
    code: LanguageCode.DUTCH,
  },
};

export const DATA_CENTERS: Readonly<Record<DataCenterCode, DataCenter>> = {
  [DataCenterCode.NORTH_AMERICA]: {
    displayName: 'North America',
    code: DataCenterCode.NORTH_AMERICA,
    prodHost: 'www.clover.com',
    stgHost: 'stg1.dev.clover.com',
    devHost: 'dev1.dev.clover.com',
  },
  [DataCenterCode.LATIN_AMERICA]: {
    displayName: 'Latin America',
    code: DataCenterCode.LATIN_AMERICA,
    prodHost: 'www.la.clover.com',
    stgHost: 'stg2.dev.clover.com',
    devHost: 'dev7.dev.clover.com',
  },
  [DataCenterCode.EUROPE]: {
    displayName: 'Europe',
    code: DataCenterCode.EUROPE,
    prodHost: 'www.eu.clover.com',
    stgHost: 'stg3.dev.clover.com',
    devHost: 'demo2.dev.clover.com',
  },
};

export const COUNTRIES: Readonly<Record<CountryCode, Country>> = {
  [CountryCode.UNITED_STATES]: {
    displayName: { en: 'United States', es: 'Estados Unidos' },
    code: CountryCode.UNITED_STATES,
    languages: [LANGUAGES.en],
    dataCenter: DATA_CENTERS[DataCenterCode.NORTH_AMERICA],
  },
  [CountryCode.CANADA]: {
    displayName: { en: 'Canada', fr: 'Canada' },
    code: CountryCode.CANADA,
    languages: [LANGUAGES.en, LANGUAGES.fr],
    dataCenter: DATA_CENTERS[DataCenterCode.NORTH_AMERICA],
  },
  [CountryCode.ARGENTINA]: {
    displayName: { en: 'Argentina', es: 'Argentina' },
    code: CountryCode.ARGENTINA,
    languages: [LANGUAGES.es],
    dataCenter: DATA_CENTERS[DataCenterCode.LATIN_AMERICA],
  },
  [CountryCode.UNITED_KINGDOM]: {
    displayName: { en: 'United Kingdom' },
    code: CountryCode.UNITED_KINGDOM,
    languages: [LANGUAGES.en],
    dataCenter: DATA_CENTERS[DataCenterCode.EUROPE],
  },
  [CountryCode.GERMANY]: {
    displayName: { en: 'Germany', de: 'Deutschland' },
    code: CountryCode.GERMANY,
    languages: [LANGUAGES.de],
    dataCenter: DATA_CENTERS[DataCenterCode.EUROPE],
  },
  [CountryCode.AUSTRIA]: {
    displayName: { en: 'Austria', de: 'Österreich' },
    code: CountryCode.AUSTRIA,
    languages: [LANGUAGES.de],
    dataCenter: DATA_CENTERS[DataCenterCode.EUROPE],
  },
  [CountryCode.IRELAND]: {
    displayName: { en: 'Ireland' },
    code: CountryCode.IRELAND,
    languages: [LANGUAGES.en],
    dataCenter: DATA_CENTERS[DataCenterCode.EUROPE],
  },
  [CountryCode.NETHERLANDS]: {
    displayName: { en: 'Netherlands', nl: 'Nederlands' },
    code: CountryCode.NETHERLANDS,
    languages: [LANGUAGES.nl],
    dataCenter: DATA_CENTERS[DataCenterCode.EUROPE],
  },
};

// All supported locales for all data centers
export const LOCALES: Readonly<Record<string, Locale>> = Object.values(COUNTRIES)
  .map(c => c.languages.map(l => new Locale(c, l)))
  .reduce((map, localeArray) => {
    const newLocales = localeArray.reduce((acc, locale) => ({ ...acc, [locale.code]: locale }), {});

    return { ...map, ...newLocales };
  }, {} as Record<string, Locale>);

export const DEFAULT_LANGUAGE_CODE = LanguageCode.ENGLISH;
export const DEFAULT_LOCALE_CODE = 'en-US';
export const DEFAULT_LOCALE = LOCALES[DEFAULT_LOCALE_CODE];
